import { AlertType } from '@/constants/ui'
import { useAlertManagerStore } from '@/stores/alertManager'
import { translationFunctionDefault } from '@/utilities/translations'

const translationKey = (key: string): string => {
  return `frappeInterceptNewCreateActionMap.bankAccountPaymentCodeBlock.${key}`
}

/**
 * Hard-block alert shown when the user tries to remove, deactivate, or unset the
 * company's default bank account while the payment QR code feature
 * (Company.tw_show_payment_code) is enabled. The QR code on print formats relies
 * on that account, so the action is not allowed (close-only, no confirm CTA).
 */
const openBankAccountPaymentCodeBlockAlert = (): void => {
  const tfDefault = translationFunctionDefault()
  const alertManagerStore = useAlertManagerStore()

  alertManagerStore.openAlert({
    alertType: AlertType.warning,
    cancelLabel: tfDefault(translationKey('closeLabel')),
    message: tfDefault(translationKey('message')),
    messageTitle: tfDefault(translationKey('title')),
  })
}

export { openBankAccountPaymentCodeBlockAlert }
